import React, { useState } from 'react'
import { ThreeDots } from 'assets/icons/ThreeDots'
import { useNavigate } from 'react-router-dom'
import { Dropdown, EditContainer, Flex } from 'styling/GlobalStyles'
import { handleOptionBtn } from 'utils/helpers'
import { OtherText } from 'styling/Typography'
import { OptionsFileIcon } from 'assets/icons/OptionsFileIcon'
import { OptionsDeleteIcon } from 'assets/icons/OptionsDeleteIcon'
import { OptionsDuplicateIcon } from 'assets/icons/OptionsDuplicateIcon'
import { EditIcon } from 'assets/icons/EditIcon'
import { CloseIcon } from 'assets/icons/CloseIcon'
/*eslint-disable */

export const Options = ({
  item,
  title,
  handleRemove,
  removeCompany,
  removeLocation,
  handleDuplicate,
  invisible,
  openModal,
  absolute
}: {
  item: any
  title: string
  handleRemove?: any
  removeCompany?: (id) => void
  removeLocation?: (id) => void
  handleDuplicate?: any
  invisible?: boolean,
  openModal?: any
  absolute?: boolean
  /* eslint-enable */
}) => {
  const [editID, setEditID] = useState(false)
  const [showEditMenu, setShowEditMenu] = useState(false)
  const navigate = useNavigate()

  const handleViewEmployee = (id: string) => {
    if (location.pathname == '/') {
      navigate('hr/employees/' + id)
    } else {
      navigate(id)
    }
  }
  const findId = () => {
    if (title === 'MachineModel') {
      return editID === item.machineModel.id
    }
    return editID === item.id
  }
  return (
    <>
      <EditContainer
        absolute={absolute}
        tabIndex={0}
        invisible={invisible}
        onBlur={() => setShowEditMenu(false)}
        onClick={(e) => {
          e.stopPropagation()
          handleOptionBtn(item, setEditID, setShowEditMenu, Number(editID))
        }}
        show={editID === item.id && showEditMenu}
      >
        <span><ThreeDots /></span>

        {findId() ? ( // TODO Hover
          <Dropdown show={showEditMenu} left>
            {title === 'Employee' ? (
              <>
                <Flex gap='10px' onClick={() => handleViewEmployee(item.id.toString() + '/edit')}>
                  <OptionsFileIcon /> <OtherText>Edit </OtherText>
                </Flex>
                <Flex gap='10px' onClick={handleRemove}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
                {!item?.contractTerminationRequest?.id && <Flex gap='10px' onClick={() => openModal(item.id)}>
                  <CloseIcon /> <OtherText>Terminate Contract</OtherText>
                </Flex>}
              </>
            ) : title === 'Machine Model' ? (
              <>
                <Flex gap='10px' onClick={() => navigate(item.id.toString())}>
                  <OptionsFileIcon /> <OtherText>Edit</OtherText>
                </Flex>
                <Flex gap='10px' onClick={handleRemove}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
              </>
            ) : title === 'Task Template' ? (
              <>
                <Flex gap='10px' onClick={() => navigate('/task-templates/' + item.id + '/edit')}>
                  <OptionsFileIcon /><OtherText> Edit</OtherText>
                </Flex>
                <Flex gap='10px' onClick={handleRemove}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
                <Flex gap='10px' onClick={handleDuplicate}>
                  <OptionsDuplicateIcon /> <OtherText>Duplicate</OtherText>
                </Flex>
              </>
            ) : title === 'Company' ? (
              <>
                <Flex
                  gap='10px'
                  onClick={() => {
                    navigate('edit/' + item.id)
                  }}
                >
                  <OptionsFileIcon /> <OtherText>Edit</OtherText>
                </Flex>

                <Flex gap='10px' onClick={() => removeCompany(item.id)}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
              </>
            ) : title == 'Tasks' ? <>
              <Flex gap='10px' onClick={() => navigate('/dashboard/tasks/' + (item.task ? item.task.id.toString() : item.workflow.id.toString()) + '?fromTasks=true')}>
                <OptionsFileIcon /> <OtherText>View</OtherText>
              </Flex>
              <Flex gap='10px' onClick={handleRemove}>
                <OptionsDeleteIcon />  <OtherText>Delete</OtherText>
              </Flex>
            </> : title === 'Location' ? (
              <>
                <Flex gap='10px' onClick={() => navigate('edit/' + item.id)}>
                  <OptionsFileIcon /> <OtherText>Edit</OtherText>
                </Flex>
                <Flex gap='10px' onClick={() => removeLocation(item.id)}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
              </>
            ) : title === 'Inventory Item' ? (
              <>
                <Flex gap='10px' onClick={() => navigate('edit/' + item.id)}>
                  <OptionsFileIcon /> <OtherText> Edit</OtherText>
                </Flex>
                <Flex gap='10px' onClick={handleRemove}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
              </>
            ) : title === 'Supplier' ? (
              <>
                <Flex gap='10px' onClick={() => navigate(item.id.toString())}>
                  <OptionsFileIcon /> <OtherText>Edit</OtherText>
                </Flex>
                <Flex gap='10px' onClick={handleRemove}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
              </>
            ) : title === 'Machinery' ? (
              <>
                <Flex
                  gap='10px'
                  onClick={() => {
                    navigate(item.id.toString())
                  }}
                >
                  <OptionsFileIcon /> <OtherText>Edit</OtherText>
                </Flex>
                <Flex gap='10px' onClick={handleRemove}>
                  <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                </Flex>
              </>
            ) : title === 'Report' ? (
              <>
                <Flex
                  gap='10px'
                  onClick={() => {
                    navigate('/analytics/report/' + item.id.toString())
                  }}
                >
                  <OptionsFileIcon /> <OtherText>View</OtherText>
                </Flex>
                {/* <Flex gap='10px' onClick={handleRemove}>
                  {DownloadIcon} Download Report
                </Flex> */}
              </>
            )
              : title === 'Ingredient' ? (
                <>
                  <Flex
                    gap='10px'
                    onClick={openModal}
                  >
                    <EditIcon /> <OtherText>Edit</OtherText>
                  </Flex>
                  <Flex gap='10px' onClick={handleRemove}>
                    <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                  </Flex>
                  {/* <Flex gap='10px' onClick={handleRemove}>
                  {DownloadIcon} Download Report
                </Flex> */}
                </>
              ) : title === 'Food Item' ? (
                <>
                  <Flex
                    gap='10px'
                    onClick={openModal}
                  >
                    <EditIcon /> <OtherText>Edit</OtherText>
                  </Flex>
                  <Flex gap='10px' onClick={handleRemove}>
                    <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                  </Flex>
                  {/* <Flex gap='10px' onClick={handleRemove}>
                  {DownloadIcon} Download Report
                </Flex> */}
                </>
              ) : title === 'Meal Type' ? (
                <>
                  <Flex
                    gap='10px'
                    onClick={openModal}
                  >
                    <EditIcon /> <OtherText>Edit</OtherText>
                  </Flex>
                  <Flex gap='10px' onClick={handleRemove}>
                    <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                  </Flex>

                </>
              ) : title === 'Meal Supplier' ? (
                <>
                  <Flex
                    gap='10px'
                    onClick={openModal}
                  >
                    <EditIcon /> <OtherText>Edit</OtherText>
                  </Flex>
                  <Flex gap='10px' onClick={handleRemove}>
                    <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                  </Flex>
                </>
              ) : title === 'Dish' ? (
                <>
                  <Flex
                    gap='10px'
                    onClick={openModal}
                  >
                    <EditIcon /> <OtherText>Edit</OtherText>
                  </Flex>
                  <Flex gap='10px' onClick={handleRemove}>
                    <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                  </Flex>

                </>
              ) :
                title === 'Accommodation' ? (
                  <>

                    <Flex
                      gap='10px'
                      onClick={() => navigate(item.id.toString() + '/edit')}
                    >
                      <EditIcon /> <OtherText>Edit</OtherText>
                    </Flex>
                    <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                      <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                    </Flex>

                  </>
                ) :
                  title === 'Accommodation Users' ? (
                    <>
                      <Flex
                        gap='10px'
                        onClick={() => openModal(item.type == 1 ? item.user.id : item.guest.id)}
                      >
                        <OptionsFileIcon /> <OtherText>Check Out</OtherText>
                      </Flex>


                    </>
                  ) :
                    title === 'Company Admin' ? (
                      <>
                        <Flex
                          gap='10px'
                          onClick={openModal}
                        >
                          <EditIcon /> <OtherText>Edit</OtherText>
                        </Flex>
                        <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                          <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                        </Flex>

                      </>
                    ) :
                      title === 'Transfer Point' ? (
                        <>
                          <Flex
                            gap='10px'
                            onClick={openModal}
                          >
                            <EditIcon /> <OtherText>Edit Point</OtherText>
                          </Flex>
                          <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                            <OptionsDeleteIcon /> <OtherText>Delete Point</OtherText>
                          </Flex>

                        </>
                      ) :

                        title === 'Work Schedule Model' ? (
                          <>
                            <Flex
                              gap='10px'
                              onClick={openModal}
                            >
                              <EditIcon /> <OtherText>Edit Model</OtherText>
                            </Flex>
                            <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                              <OptionsDeleteIcon /> <OtherText>Delete Model</OtherText>
                            </Flex>

                          </>
                        ) :
                          title === 'Transportation Vehicle' ? (
                            <>
                              <Flex
                                gap='10px'
                                onClick={openModal}
                              >
                                <EditIcon /> <OtherText>Edit Vehicle</OtherText>
                              </Flex>
                              <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                                <OptionsDeleteIcon /> <OtherText>Delete Vehicle</OtherText>
                              </Flex>

                            </>
                          ) :
                            title === 'Room' ? (
                              <>
                                {/* <Flex // TOOD
                          gap='10px'
                          onClick={openModal}
                        >
                          <EditIcon /> <OtherText>Edit Room</OtherText>
                        </Flex> */}
                                <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                                  <OptionsDeleteIcon /> <OtherText>Delete Room</OtherText>
                                </Flex>

                              </>
                            ) :
                              title === 'Payroll' ? (
                                <>
                                  <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                                    <OptionsDeleteIcon /> <OtherText>Delete Payroll</OtherText>
                                  </Flex>

                                </>
                              )
                                :
                                title === 'Shift' ? (
                                  <>
                                    <Flex
                                      gap='10px'
                                      onClick={openModal}
                                    >
                                      <OptionsFileIcon /> <OtherText>Edit Shift</OtherText>
                                    </Flex>
                                    <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                                      <OptionsDeleteIcon /> <OtherText>Delete Shift</OtherText>
                                    </Flex>
                                  </>
                                )
                                  :
                                  title === 'Cost Center' ? (
                                    <>
                                      <Flex
                                        gap='10px'
                                        onClick={openModal}
                                      >
                                        <OptionsFileIcon /> <OtherText>Edit Record</OtherText>
                                      </Flex>
                                      <Flex gap='10px' onClick={() => handleRemove(item.id)}>
                                        <OptionsDeleteIcon /> <OtherText>Delete Record</OtherText>
                                      </Flex>
                                    </>
                                  )
                                    :
                                    title === 'Receipts' ? (
                                      <>
                                        <Flex gap='10px' onClick={() => openModal(true)}>
                                          <OptionsFileIcon /> <OtherText>Approve</OtherText>
                                        </Flex>
                                        <Flex gap='10px' onClick={() => openModal(false)}>
                                          <OptionsFileIcon /> <OtherText>Reject</OtherText>
                                        </Flex>
                                      </>
                                    )
                                      :
                                      title === 'Fuel Suppliers' ? (
                                        <>
                                          <Flex gap='10px' onClick={openModal}>
                                            <EditIcon /> <OtherText>Edit</OtherText>
                                          </Flex>
                                          <Flex
                                            gap='10px'
                                            onClick={() => handleRemove(item.id)}
                                          >
                                            <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                                          </Flex>

                                        </>
                                      )
                                        :
                                        title === 'Fuel Tanks' ? (
                                          <>
                                            <Flex gap='10px' onClick={openModal}>
                                              <EditIcon /> <OtherText>Edit</OtherText>
                                            </Flex>
                                            <Flex
                                              gap='10px'
                                              onClick={() => handleRemove(item.id)}
                                            >
                                              <OptionsDeleteIcon /> <OtherText>Delete</OtherText>
                                            </Flex>

                                          </>
                                        )
                                          :
                                          title === 'Inventory Transfers' ? (
                                            <>
                                              <Flex gap='10px' onClick={() => openModal(item)}>
                                                <EditIcon /> <OtherText>View</OtherText>
                                              </Flex>

                                            </>
                                          )
                                            :
                                            title === 'Requests' ? (
                                              <>
                                                <Flex gap='10px' onClick={() => openModal(item.id, true)}>
                                                  <OptionsFileIcon /> <OtherText>Approve</OtherText>
                                                </Flex>
                                                <Flex gap='10px' onClick={() => openModal(item.id, false)}>
                                                  <OptionsFileIcon /> <OtherText>Decline</OtherText>
                                                </Flex>

                                              </>
                                            )
                                              : (
                                                <>

                                                  <Flex gap='10px' onClick={() => navigate(item.id)}>
                                                    <OptionsFileIcon /> <OtherText>View {title}</OtherText>
                                                  </Flex>
                                                </>
                                              )}
          </Dropdown>
        ) : null}
      </EditContainer>
    </>
  )
}
